export const VivaEngage = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16px" height="16px" viewBox="0 0 18 18" {...props}>
    <g fill="transparent" stroke="currentColor">
      <path d="M4.9.5a4 4 0 0 1 3.9 4v5H1v-5a4 4 0 0 1 3.9-4ZM9.7 4.5a4 4 0 0 1 4-4 4 4 0 0 1 3.8 4v5.1H9.7V4.5Z" />
      <path d="M9.3 3.3a4 4 0 0 1 3.8 4 4 4 0 0 1-3.8 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4Z" />
      <path d="M17.5 11.3V7a6 6 0 0 1-4.7 2.5 4 4 0 0 0-4 4 4 4 0 0 0 4 4c2 0 3.1-1 3.8-2.3.7-1.3.9-2.9.9-3.9Z" />
      <path d="M1 11.4V7a6 6 0 0 0 4.7 2.6 4 4 0 0 1 4 4 4 4 0 0 1-4 4c-2 0-3.1-1-3.8-2.3a8.6 8.6 0 0 1-.9-4Z" />
    </g>
  </svg>
);
